/*jshint esversion:6*/
import React, { Component } from 'react';

export default class AboutMe extends Component {
    /*jshint ignore:start*/
    render() {
        return (
            <div>
            <section id="aboutMe">
                <span style={{flexDirection:"column"}}>
                    <p>
                    Graduated from Technical University of Cluj-Napoca, Automation section, I like delving into code, understand it and provide results for real world projects.
                    </p>
                </span>
             </section>   
             <div id = "contact">
                <p style={{margin:'0'}}>
                 Have an idea or want to discuss? Checkout these pages, let's talk:
                </p>
                {/*eslint-disable-next-line jsx-a11y/anchor-has-content*/}
                <a className="icon-github" href="https://github.com/MirrorIce" target="_blank" rel = "noreferrer"></a>
                {/*eslint-disable-next-line jsx-a11y/anchor-has-content*/}
                <a className="icon-linkedin" href="https://www.linkedin.com/in/bred-ciubotaru-793772133/" target="_blank" rel = "noreferrer"></a>    
            </div>
            </div>
        )
    }
    /*jshint ignore:end*/
}
